import {Component, inject} from '@angular/core'
import {RouterOutlet} from '@angular/router'
import {MatIconRegistry} from '@angular/material/icon'
import {IconComponent} from './components/icon/icon.component'
import {DomSanitizer} from '@angular/platform-browser'

@Component({
  selector: 'kdl-root',
  imports: [RouterOutlet],
  template: '<router-outlet />'
})
export class AppComponent {
  private readonly iconRegistry = inject(MatIconRegistry)
  private readonly sanitizer = inject(DomSanitizer)

  constructor() {
    IconComponent.setupIcons(this.iconRegistry, this.sanitizer)
  }
}
